import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { FillScreen, HStack, VStack } from '@/components/Layout';
import { ProductLogoMediumProductPlanningCore } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import { Separator } from '@/components/ui/separator';
import { PackageSidebar, type SidebarState } from '@/features/operation-package/PackageSidebar';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { MockContent } from './product-planning-core/-components/MockContent';
export const Route = createFileRoute('/_stacktrace/product-planning-core')({
  component: ProductPlanningCorePage
});
const PRODUCT_ROADMAP_DRAFTING_ID = 'product-roadmap-drafting';
const PRODUCT_ROADMAP_CHANGE_ID = 'product-roadmap-change';
function ProductPlanningCoreLogo({
  size = 40
}: {
  size?: number;
}) {
  return <ProductLogoMediumProductPlanningCore size={size} />;
}
function ProductPlanningCorePage() {
  const {
    t
  } = useTranslation();
  const {
    t: tSidebar
  } = useTranslation(stacktraceNS, {
    keyPrefix: 'productPlanningCore.sidebar'
  });
  const title = t('component.sidebar.ppForceProductPlanningCore');
  useDocumentTitle(title);
  const sidebarGroups = [{
    packages: [{
      id: PRODUCT_ROADMAP_DRAFTING_ID,
      label: tSidebar('productRoadmapDrafting'),
      isUnderDevelopment: true
    }, {
      id: PRODUCT_ROADMAP_CHANGE_ID,
      label: tSidebar('productRoadmapChange'),
      isUnderDevelopment: true
    }]
  }];
  const [activeId, setActiveId] = useState<string>(PRODUCT_ROADMAP_DRAFTING_ID);
  const [sidebarState, setSidebarState] = useState<SidebarState>('open');
  const activeLabel = sidebarGroups.flatMap(group => group.packages).find(item => item.id === activeId)?.label ?? '';
  const tabs: TabWithIndicatorProps[] = [{
    to: '/product-planning-core' as const,
    children: 'オペレーションパッケージ',
    activeOptions: {
      exact: true,
      includeSearch: true
    }
  }, {
    to: '/product-planning-core/archives' as never,
    children: 'アーカイブ',
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/product-planning-core/configs' as never,
    children: '設定',
    disabled: true,
    activeOptions: {
      exact: true
    }
  }];
  return <VStack className="h-full">
      <ProductHeader Logo={ProductPlanningCoreLogo} name={title} tabs={tabs} type="core" />
      <FillScreen>
        <HStack className="h-full w-full max-w-screen">
          <PackageSidebar groups={sidebarGroups} activeId={activeId} onSelect={setActiveId} sidebarState={sidebarState} onStateChange={setSidebarState} underDevelopmentText={tSidebar('underDevelopment')} />
          <Separator orientation="vertical" />
          <MockContent activeLabel={activeLabel} />
        </HStack>
      </FillScreen>
    </VStack>;
}